import {
  IWebsiteBuilderGrid,
  websiteBuilderGenerateGridDesignStyles,
} from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderGrid";
import React, { ReactNode } from "react";

interface IWebsiteBuilderGridViewProps {
  node: IWebsiteBuilderGrid;
  children: ReactNode;
}

export function WebsiteBuilderGridView(props: IWebsiteBuilderGridViewProps) {
  const { node, children } = props;

  const settings = node.container.settings;
  const designStyles = websiteBuilderGenerateGridDesignStyles(settings);

  return (
    <div className={designStyles.containerClassName}>
      <div
        className={designStyles.className}
        style={designStyles.styleProperties}
      >
        {children}
      </div>
    </div>
  );
}
